import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "adjustmentDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "adjustmentDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header border-bottom-dashed" }
const _hoisted_5 = {
  class: "modal-title text-title fw-bold",
  id: "adjustmentDetailsModalLabel"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_8 = { class: "d-flex justify-content-center align-items-center py-5" }
const _hoisted_9 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_10 = { class: "visually-hidden" }
const _hoisted_11 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_12 = { class: "row mb-4" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "mb-1 text-muted fs-13" }
const _hoisted_15 = { class: "fw-semibold text-dark" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "mb-1 text-muted fs-13" }
const _hoisted_18 = { class: "fw-semibold text-dark" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "mb-1 text-muted fs-13" }
const _hoisted_21 = { class: "fw-semibold text-dark" }
const _hoisted_22 = { class: "fw-bold mb-3" }
const _hoisted_23 = { class: "table-responsive style-two" }
const _hoisted_24 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_25 = { class: "bg-light" }
const _hoisted_26 = {
  scope: "col",
  class: "text-title fw-semibold fs-13 lh-1"
}
const _hoisted_27 = {
  scope: "col",
  class: "text-title fw-semibold fs-13 lh-1"
}
const _hoisted_28 = {
  scope: "col",
  class: "text-title fw-semibold fs-13 lh-1"
}
const _hoisted_29 = {
  scope: "col",
  class: "text-title fw-semibold fs-13 lh-1"
}
const _hoisted_30 = {
  scope: "col",
  class: "text-title fw-semibold fs-13 lh-1"
}
const _hoisted_31 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_32 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_33 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_34 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_35 = { class: "shadow-none lh-1 fs-14 fw-normal" }
const _hoisted_36 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_37 = { class: "fw-bold mb-2" }
const _hoisted_38 = { class: "text-paragraph fs-14 bg-light p-3 rounded" }
const _hoisted_39 = { class: "modal-footer border-top-dashed" }
const _hoisted_40 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_41 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.adjustment || _ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.t("adjustment_page.adjustment_details")) + _toDisplayString(_ctx.adjustment?.ref ? `: ${_ctx.adjustment.ref}` : ""), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close p-0 shadow-none",
                "data-bs-dismiss": "modal",
                "aria-label": _ctx.t('common.close')
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "ri-close-line fs-24" }, null, -1)
              ]))], 8, _hoisted_6)
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t("loading")), 1)
                    ])
                  ])
                ]))
              : (_ctx.adjustment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t("adjustment_page.date_label")), 1),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.adjustment.created_at)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t("adjustment_page.reference_label")), 1),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.adjustment.ref), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.t("adjustment_page.warehouse_label")), 1),
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.adjustment.warehouse_name), 1)
                      ])
                    ]),
                    _createElementVNode("h6", _hoisted_22, _toDisplayString(_ctx.t("adjustment_page.adjusted_products")), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("table", _hoisted_24, [
                        _createElementVNode("thead", _hoisted_25, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.t("adjustment_page.no")), 1),
                            _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.t("adjustment_page.product")), 1),
                            _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.t("adjustment_page.code")), 1),
                            _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.t("adjustment_page.quantity")), 1),
                            _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.t("adjustment_page.type")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustment.items, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_31, _toDisplayString(Number(index) + 1) + ". ", 1),
                              _createElementVNode("td", _hoisted_32, _toDisplayString(item.product?.name || _ctx.t("adjustment_page.not_available")), 1),
                              _createElementVNode("td", _hoisted_33, _toDisplayString(item.product?.code || _ctx.t("adjustment_page.not_available")), 1),
                              _createElementVNode("td", _hoisted_34, _toDisplayString(item.quantity), 1),
                              _createElementVNode("td", _hoisted_35, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(item.type === 'add' ? 'text-success' : 'text-danger')
                                }, _toDisplayString(item.type === 'add' ? _ctx.t("adjustment_page.addition") : _ctx.t("adjustment_page.subtraction")), 3)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    (_ctx.adjustment.note)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("h6", _hoisted_37, _toDisplayString(_ctx.t("adjustment_page.note_label")), 1),
                          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.adjustment.note), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", _hoisted_40, _toDisplayString(_ctx.t("common.close")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePrint && _ctx.handlePrint(...args))),
                disabled: _ctx.loading || !_ctx.adjustment
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-printer-line me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t("adjustment_page.print")), 1)
              ], 8, _hoisted_41)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}